import { render } from "./Todo.vue?vue&type=template&id=3698eee9"
import script from "./Todo.vue?vue&type=script&lang=ts"
export * from "./Todo.vue?vue&type=script&lang=ts"
script.render = render

export default script